import React, { useState } from 'react';
import UPSELLerateLogo from '../UPSELLerate-logo';
import { useI18n } from '../context/i18n';
import './Register.css';

const Register = () => {
  const { language } = useI18n();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    industry: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const text = {
    title: language === 'en' ? 'Create your account' : 'Crea tu cuenta',
    subtitle: language === 'en' ? 'Start discovering growth opportunities with AI' : 'Comienza a descubrir oportunidades de crecimiento con IA',
    corporateEmail: language === 'en' ? 'Corporate email' : 'Email corporativo',
    emailPlaceholder: language === 'en' ? 'name@company.com' : 'nombre@empresa.com',
    password: language === 'en' ? 'Password' : 'Contraseña',
    passwordPlaceholder: language === 'en' ? 'Create a secure password' : 'Crea una contraseña segura',
    showPassword: language === 'en' ? 'Show password' : 'Mostrar contraseña',
    hidePassword: language === 'en' ? 'Hide password' : 'Ocultar contraseña',
    confirmPassword: language === 'en' ? 'Confirm password' : 'Confirmar contraseña',
    confirmPasswordPlaceholder: language === 'en' ? 'Confirm your password' : 'Confirma tu contraseña',
    companyName: language === 'en' ? 'Company name' : 'Nombre de la empresa',
    companyPlaceholder: language === 'en' ? 'Your company' : 'Tu empresa',
    industry: language === 'en' ? 'Industry' : 'Industria',
    termsPrefix: language === 'en' ? 'I agree to the' : 'Acepto los',
    terms: language === 'en' ? 'Terms of Service' : 'Términos de Servicio',
    and: language === 'en' ? 'and' : 'y la',
    privacy: language === 'en' ? 'Privacy Policy' : 'Política de Privacidad',
    createAccount: language === 'en' ? 'Create account' : 'Crear cuenta',
    hasAccount: language === 'en' ? 'Already have an account?' : '¿Ya tienes una cuenta?',
    signIn: language === 'en' ? 'Sign in' : 'Inicia sesión',
    rightTitle: language === 'en' ? 'Turn your data into smarter decisions' : 'Transforma tus datos en decisiones inteligentes',
    rightSubtitle: language === 'en'
      ? 'Join companies already leveraging AI to uncover hidden opportunities in their data.'
      : 'Únete a las empresas que ya están aprovechando el poder de la inteligencia artificial para descubrir oportunidades ocultas en sus datos.',
    feature1Title: language === 'en' ? 'AI Analytics' : 'Análisis con IA',
    feature1Text: language === 'en' ? 'Query your data in natural language and get actionable insights instantly' : 'Consulta tus datos en lenguaje natural y obtén insights accionables al instante',
    feature2Text: language === 'en' ? 'Automatically identify growth and upselling opportunities' : 'Identifica automáticamente oportunidades de crecimiento y upselling',
    feature3Title: language === 'en' ? 'Enterprise Security' : 'Seguridad Enterprise',
    feature3Text: language === 'en' ? 'Your data is protected with enterprise-grade encryption' : 'Tus datos están protegidos con encriptación de nivel empresarial',
    trust: language === 'en' ? '50+ companies trust UPSELLerate' : '+50 empresas confían en UPSELLerate'
  };

  const industries = [
    { value: '', label: language === 'en' ? 'Select an industry' : 'Selecciona una industria' },
    { value: 'retail', label: 'Retail / E-commerce' },
    { value: 'technology', label: language === 'en' ? 'Technology / SaaS' : 'Tecnología / SaaS' },
    { value: 'finance', label: language === 'en' ? 'Finance / Banking' : 'Finanzas / Banca' },
    { value: 'healthcare', label: language === 'en' ? 'Healthcare / Pharma' : 'Salud / Farmacéutica' },
    { value: 'manufacturing', label: language === 'en' ? 'Manufacturing' : 'Manufactura' },
    { value: 'services', label: language === 'en' ? 'Professional Services' : 'Servicios Profesionales' },
    { value: 'education', label: language === 'en' ? 'Education' : 'Educación' },
    { value: 'hospitality', label: language === 'en' ? 'Hospitality / Tourism' : 'Hotelería / Turismo' },
    { value: 'other', label: language === 'en' ? 'Other' : 'Otra' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Solo maquetación - sin lógica funcional
    console.log('Form submitted:', formData);
  };

  return (
    <div className="register-container">
      {/* Columna Izquierda - Formulario */}
      <div className="register-left">
        <div className="register-card">
          <div className="register-header">
            <div className="logo">
              <UPSELLerateLogo width={280} />
            </div>
            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>
          </div>

          <form onSubmit={handleSubmit} className="register-form">
            <div className="input-group">
              <label>{text.corporateEmail}</label>
              <input
                type="email"
                name="email"
                placeholder={text.emailPlaceholder}
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label>{text.password}</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder={text.passwordPlaceholder}
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? text.hidePassword : text.showPassword}
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="input-group">
              <label>{text.confirmPassword}</label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmPassword"
                  placeholder={text.confirmPasswordPlaceholder}
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  aria-label={showConfirmPassword ? text.hidePassword : text.showPassword}
                >
                  {showConfirmPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="input-group">
              <label>{text.companyName}</label>
              <input
                type="text"
                name="companyName"
                placeholder={text.companyPlaceholder}
                value={formData.companyName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label>{text.industry}</label>
              <select
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                required
              >
                {industries.map(industry => (
                  <option key={industry.value} value={industry.value}>
                    {industry.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="terms-checkbox">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  required
                />
                <span className="checkmark"></span>
                <span className="terms-text">
                  {text.termsPrefix} <a href="/terms">{text.terms}</a> {text.and} <a href="/privacy">{text.privacy}</a>
                </span>
              </label>
            </div>

            <button type="submit" className="register-button">
              {text.createAccount}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>

            <p className="login-link">
              {text.hasAccount} <a href="/login">{text.signIn}</a>
            </p>
          </form>
        </div>
      </div>

      {/* Columna Derecha - Panel informativo */}
      <div className="register-right">
        <div className="grid-pattern"></div>
        <div className="right-content">
          <h2>{text.rightTitle}</h2>
          <p className="right-subtitle">
            {text.rightSubtitle}
          </p>

          <div className="features-list">
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
              <div className="feature-text">
                <h3>{text.feature1Title}</h3>
                <p>{text.feature1Text}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              <div className="feature-text">
                <h3>Golden Opportunities</h3>
                <p>{text.feature2Text}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <div className="feature-text">
                <h3>{text.feature3Title}</h3>
                <p>{text.feature3Text}</p>
              </div>
            </div>
          </div>

          <div className="trust-badge">
            <div className="trust-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <span>{text.trust}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
